(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('PortalRoleSearch', PortalRoleSearch);

    PortalRoleSearch.$inject = ['$resource'];

    function PortalRoleSearch($resource) {
        var resourceUrl =  'api/_search/portal-roles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
